import { render, staticRenderFns } from "./account-payables-overview.vue?vue&type=template&id=dbd77aee"
import script from "./account-payables-overview.vue?vue&type=script&lang=js"
export * from "./account-payables-overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports